module.exports = __webpack_public_path__ + "da274af8f834f98d0219a5bc05251fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/accessory-detail-content/icon_catalog_dark.png
// module id = 879
// module chunks = 0 1